module.exports = __webpack_public_path__ + "img/medalj.52c9e177.png";